import { toast } from "react-toastify";
import { onAddPosition, ongetOrgPosition } from "../services/position";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { useEffect, useState } from "react";

export default () => {
  const { config, SelectedOrg } = useStateGetter();
  const { setLoading } = useStateSetter();
  const [allorgPositions, setallorgPositions] = useState<any[]>([]);





  const AddPosition = async (postdata: any) => {
    try {
      setLoading(true);
      var response = await onAddPosition(postdata, config);
      toast.success(response.message);
      setLoading(false);
    } catch (e: any) {
   
      console.log(e);
      toast.error(e);
    }
  };

  const getPositionById = () => {};

  const getOrgPositions = async () => {
setLoading(true)
    try{
        var response =await  ongetOrgPosition(SelectedOrg.id,config)
        setallorgPositions(response.data)
        setLoading(false)

    }
catch(e:any){

  setLoading(false)

    console.log(e)
    
}






  };

  const refresh =async ()=>{

   await getOrgPositions()

  }
useEffect(()=>{

    getOrgPositions()

},[])
  return { AddPosition , refresh,allorgPositions};
};
